export const ACTION_SELECT_PRODUCT = 'PRODUCT_SELECT';

export const selectProduct = data => ({
  type: ACTION_SELECT_PRODUCT,
  data
});

